import salesExpensesMSTEditPage from './SalesExpensesMSTEditPage';

export default salesExpensesMSTEditPage;
